import { ConfigProvider, Menu, Popover } from 'antd';
import React, { useEffect, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import type { MenuProps } from 'antd';
import classNames from 'classnames';
import {
  greyColor, maxMobile, maxTablet, maxWidth, primaryColor, primaryFont, retina, wMedium,
} from 'Utils/utilsStyle';
import { IsMobile, IsTablet } from 'Utils/UtilityFunctions';
import GlobalButton from './GlobalButton';
import DownAngleIcon from '../assets/svgIcons/DownAngleIcon';
import CompaniesSvg from '../../layout/assets/CompaniesSvg';
import WorldIcon from '../assets/svgIcons/WorldIcon';
import SinglePersonIcon from '../assets/svgIcons/SinglePersonIcon';
import JobLevelIcon from '../assets/svgIcons/JobLevelIcon';
import JobTitleIcon from '../assets/svgIcons/JobTitleIcon';
import PeopleSubFilterComponent, { isSubFilterOptionSelected, SubFilterOption } from './PeopleSubFilterComponent';
import { Filter } from '../../../Types/FilterTypes';
import { CompanyDistinctsData } from '../../../Types/ResponseBodies';
import { PeopleFilterSelections, SubFilterSelection } from '../../../Types/GlobalTypes';
import { actions } from '../../../Slice/FilterSlice';
import { useDispatch } from 'react-redux';
import FilterNewIcon from '../assets/svgIcons/FilterNewIcon';

const FiltersPopupStyle = createGlobalStyle`
  .ant-popover.people-filters-popup {
  &.ant-popover-placement-bottomLeft,
  &.ant-popover-placement-bottomRight {
    padding-top: 0px !important;
  }
  @media all and (max-width: ${maxMobile}) {
    overflow: visible !important;
    .ant-popover-content,
    .ant-popover-inner,
    .ant-popover-inner-content {
      overflow: visible !important;
    }
  }
  .ant-popover-content {
    .ant-popover-arrow {
      display: none;
    }
    .ant-popover-inner {
      border-radius: 8px;
      border: 1px solid #DADADA;
      background: #FFF;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
      width: fit-content;
      padding: 10px 4px;
      .ant-popover-inner-content {
        width: unset !important;
        height: unset !important;
        padding: 0px !important;
        .menu-for-people-filters {
          @media all and (max-width: ${maxWidth}), ${retina} {
            width: 215px !important;
          }
          &.ant-menu-vertical {
            border-right: 0px !important;
          }
          .ant-menu-submenu {
            width: 100%;
            margin: 0 !important;
            border-radius: 0;
            &.ant-menu-submenu-active {
              background: #F1F1F1;
              border-radius: 6px;
              .ant-menu-submenu-title {
                &:active {
                  background: unset;
                }
                svg {
                  color: ${primaryColor};
                  path {
                    fill: ${primaryColor};
                  }
                }
                .ant-menu-title-content {
                  color: ${primaryColor};
                }
              }
            }
            &.ant-menu-submenu-vertical {
              border-right: 0px !important;
            }
            .ant-menu-submenu-title {
              &:hover {
                background-color: unset !important;
              }
              display: flex;
              align-items: center;
              width: 100%;
              height: 32px;
              margin: 0 !important;
              padding-inline: 16px 16px !important;
              color: ${greyColor};
              column-gap: 9px;
              border-radius: 6px;
              .job-title-icon, .job-level-icon, .companies-svg, .world-icon-svg {
                width: 18px;
                height: 18px;
              }
              .single-person-icon {
                width: 20px;
                height: 22px;
              }
              svg {
                min-width: 20px;
                color: ${greyColor};
              }
              .ant-menu-title-content {
                flex: 1;
                width: 100%;
                color: ${greyColor};
                font-family: ${primaryFont};
                font-size: 16px;
                font-weight: ${wMedium};
                line-height: 20px;
                letter-spacing: -0.4px;
                @media all and (max-width: ${maxWidth}), ${retina} {
                  font-size: 14px;
                  line-height: 18px;
                }
              }
              .down-angle-icon {
                position: absolute;
                right: 16px;
                transform: rotate(269deg);
              }
            }
            &.active-filter-item {
              .ant-menu-submenu-title {
                svg {
                  color: ${primaryColor};
                  path {
                    fill: ${primaryColor};
                  }
                }
                .ant-menu-title-content {
                  color: ${primaryColor};
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

const StyleWrapper = styled.div`
  .people-filters-popover {
    button {
      @media all and (max-width: ${maxTablet}) {
        width: 31px;
        height: 28px;
        padding: 0px;
        margin: 0px;
        -webkit-box-pack: center;
        justify-content: center;  
      }
   
      .separator-right {
        margin: 0px 5px 0px 10px;
        background-color: #DDD;
      }
      &.activeBtnState {
        .down-angle-icon {
          transform: rotate(180deg);
        }
      }
    }
  }
`;

const SubMenuPopupStyle = createGlobalStyle`
  .ant-menu-submenu-popup.sub-menu-for-people-filters {
    z-index: 1 !important;
    .ant-menu {
      min-width: auto !important;
      padding: 0 !important;
      border: 1px solid #DADADA;
      border-radius: 8px;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
    }
    @media all and (max-width: ${maxMobile}) {
      .ant-popover.people-filters-popup & {
        position: absolute !important;
        top: calc(100% + 8px) !important;
        right: 0 !important;
        bottom: auto !important;
        left: 0 !important;
        width: 290px !important;
        min-width: 290px !important;
        max-width: 290px !important;
        margin: 0 !important;
        transform: none !important;
        .ant-menu {
          width: 100% !important;
        }
        .sub-filter-item-wrap > div {
          width: 100% !important;
          max-width: 100%;
        }
      }
    }
    .ant-menu-item.sub-filter-menu-item,
    .sub-filter-menu-item {
      height: auto !important;
      line-height: normal !important;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      cursor: default;
      width: 100% !important;
      &:hover,
      &.ant-menu-item-active,
      &.ant-menu-item-selected {
        /* background: transparent !important;C */
      }
    }
  }
`;

const ContentWrapper = styled.div`
  .reset-button {
    display: inline-flex;
    justify-content: flex-end;
    width: 100%;
    padding-right: 16px;
    /* padding-bottom: 10px; */
    color: ${primaryColor};
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: ${wMedium};
    line-height: 20px;
    letter-spacing: -0.4px;
    cursor: pointer;
    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;
type PeopleDraftFilters = {
  [K in keyof PeopleFilterSelections]?: SubFilterSelection;
}
type Props = {
  designationData: string[],
  jobLevelData: string[],
  personalityData: Filter[],
  companyData: CompanyDistinctsData[],
  regionData: string[],
  onFetchMoreCompanies?: (searchTerm?: string) => void;
  onFetchMoreDesignations?: (searchTerm?: string) => void;
  hasMoreCompanies?: boolean;
  hasMoreDesignations?: boolean;
  companiesLoading?: boolean;
  designationsLoading?: boolean;
  initialFilters?: PeopleFilterSelections;
  onApply?: (filters: PeopleFilterSelections) => void;
  isAdvanceSearch?: boolean;
  isSimilarPeople?: boolean;
  isFollowPeople?: boolean;
  disabled?: boolean
};

const defaultProps = {
  designationData: [],
  jobLevelData: [],
  personalityData: [],
  companyData: [],
  regionData: [],
  hasMoreCompanies: false,
  hasMoreDesignations: false,
  companiesLoading: false,
  designationsLoading: false,
  initialFilters: {},
  isAdvanceSearch: false,
  isSimilarPeople: false,
  isFollowPeople: false,
  disabled: false,
};
type MenuItem = Required<MenuProps>['items'][number] & { children?: MenuItem[] };

function getItem(
  label: React.ReactNode,
  key?: React.Key | null,
  icon?: React.ReactNode,
  children?: MenuItem[],
  extra?: Record<string, unknown>,
): MenuItem {
  return {
    key, icon, children, label, ...extra,
  } as MenuItem;
}

const getSubFilterChild = (
  category: string,
  title: string,
  data: SubFilterOption[],
  hasMore?: boolean,
  onLoadMore?: (searchTerm?: string) => void,
  loading?: boolean,
  onSearch?: (searchTerm: string) => void,
  selection?: SubFilterSelection,
  applyDisabled = false,
  onSelectionChange?: (selection: SubFilterSelection) => void,
  onApply?: (category: string, selected: SubFilterSelection) => void,
) => getItem(
  <div
    className="sub-filter-item-wrap"
    onClick={(e) => e.stopPropagation()}
    onMouseDown={(e) => e.stopPropagation()}
    onKeyDown={(e) => e.stopPropagation()}
    role="presentation"
  >
    <PeopleSubFilterComponent
      category={category}
      title={title}
      data={data}
      hasMore={hasMore}
      onLoadMore={onLoadMore}
      loading={loading}
      onSearch={onSearch}
      selection={selection ?? {
        all: true,
        selected: [],
        excluded: [],
      }}
      applyDisabled={applyDisabled}
      onSelectionChange={onSelectionChange}
      onApply={onApply}
    />
  </div>,
  `${category}-panel`, undefined, undefined,
  { className: 'sub-filter-menu-item' },
);

const PeopleFilters = (props: Props) => {
  const {
    designationData,
    jobLevelData,
    personalityData,
    companyData,
    regionData,
    onFetchMoreCompanies,
    onFetchMoreDesignations,
    hasMoreCompanies,
    hasMoreDesignations,
    companiesLoading,
    designationsLoading,
    initialFilters,
    onApply,
    isAdvanceSearch,
    isSimilarPeople,
    isFollowPeople,
    disabled
  } = props;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const isMob = IsMobile();
  const isTab = IsTablet();

  const subMenuExtra = { popupClassName: 'sub-menu-for-people-filters' };

  const [filters, setFilters] = useState<PeopleFilterSelections>({});
  const [selectedFilters, setSelectedFilters] = useState<PeopleDraftFilters>({});
  const [appliedSelections, setAppliedSelections] = useState<PeopleDraftFilters>({});

  const isResetDisabled = Object.values(filters).every(
    (selection) => selection?.all === true
  );

  const emptySelection = (): SubFilterSelection => ({
    all: true,
    selected: [],
    excluded: [],
  });

  const normalizeSelection = (selection: SubFilterSelection): SubFilterSelection => (
    selection.all
      ? {
        all: true,
        selected: [...selection.selected],
        excluded: [...selection.excluded],
        excludedQueries: [...(selection.excludedQueries ?? [])],
      }
      : {
        all: false,
        selected: [...selection.selected],
        excluded: [],
        excludedQueries: [...(selection.excludedQueries ?? [])],
      }
  );

  const areArraysEqual = (first: string[], second: string[]) => {
    if (first.length !== second.length) return false;

    const firstSet = new Set(first);
    const secondSet = new Set(second);

    return [...firstSet].every(value => secondSet.has(value));
  };

  const getAppliedSelection = (category: keyof PeopleFilterSelections): SubFilterSelection => (
    appliedSelections[category] ?? emptySelection()
  );

  const areSelectionsEqual = (
    first: SubFilterSelection,
    second: SubFilterSelection,
  ) => {
    if (first.all !== second.all) {
      return false;
    }
    if (first.all) {
      return areArraysEqual(first.excluded, second.excluded)
        && areArraysEqual(first.excludedQueries ?? [], second.excludedQueries ?? [])
        && areArraysEqual(first.selected, second.selected);
    }
    return areArraysEqual(first.selected, second.selected)
      && areArraysEqual(first.excludedQueries ?? [], second.excludedQueries ?? []);
  };

  const areFiltersEqual = (first: PeopleFilterSelections, second: PeopleFilterSelections) => {
    const categories: (keyof PeopleFilterSelections)[] = [
      'jobTitle', 'jobLevel', 'personality', 'company', 'region',
    ];

    return categories.every((category) => areArraysEqual(
      first[category] ?? [],
      second[category] ?? [],
    ));
  };

  const getSelection = (
    category: keyof PeopleFilterSelections,
  ): SubFilterSelection => (
    selectedFilters[category] ?? emptySelection()
  );

  const isApplyDisabled = (category: keyof PeopleFilterSelections) => (
    areSelectionsEqual(getSelection(category), getAppliedSelection(category))
  );

  const convertFiltersToDraft = (source: PeopleFilterSelections): PeopleDraftFilters => {
    const draft: PeopleDraftFilters = {};

    Object.entries(source).forEach(([category, values]) => {
      if (values) {
        draft[category as keyof PeopleFilterSelections] = {
          all: false,
          selected: values,
          excluded: [],
        };
      }
    });

    return draft;
  };

  useEffect(() => {
    const nextFilters = initialFilters ?? {};

    if (areFiltersEqual(nextFilters, filters)) {
      return;
    }
    const nextDraft = convertFiltersToDraft(nextFilters);
    setFilters(nextFilters);
    setSelectedFilters(nextDraft);
    setAppliedSelections(nextDraft);
  }, [initialFilters]);

  const onCompanySearch = (searchTerm: string) => {
    if (isAdvanceSearch) {
      dispatch(actions.setAdvCompanySearchTerm(searchTerm));
    } else if (isSimilarPeople) {
      dispatch(actions.setSimilarCompanySearchTerm(searchTerm));
    } else if (isFollowPeople) {
      dispatch(actions.setFollowCompanySearchTerm(searchTerm));
    } else {
      dispatch(actions.setCompanySearchTerm(searchTerm));
    }
  };
  const onDesignationSearch = (searchTerm: string) => {
    if (isAdvanceSearch) {
      dispatch(actions.setAdvDesignationSearchTerm(searchTerm));
    } else if (isSimilarPeople) {
      dispatch(actions.setSimialrDesignationSearchTerm(searchTerm));
    } else if (isFollowPeople) {
      dispatch(actions.setFollowDesignationSearchTerm(searchTerm));
    } else {
      dispatch(actions.setDesignationSearchTerm(searchTerm));
    }
  };

  const getOptionName = (option: SubFilterOption) => {
    if (typeof option === 'string') {
      return option;
    }

    if ('filterName' in option) {
      return option.filterName;
    }

    return option.companyName ?? '';
  };

  const getCategoryOptionNames = (category: keyof PeopleFilterSelections) => {
    const dataByCategory: Record<keyof PeopleFilterSelections, SubFilterOption[]> = {
      jobTitle: designationData,
      jobLevel: jobLevelData,
      personality: personalityData,
      company: companyData,
      region: regionData,
    };

    return (dataByCategory[category] ?? []).map(getOptionName).filter(Boolean);
  };
  const toParentFilters = (
    current: PeopleFilterSelections,
    category: keyof PeopleFilterSelections,
    selection: SubFilterSelection,
  ): PeopleFilterSelections => {
    const nextFilters = { ...current };

    const hasExclusions = selection.excluded.length > 0
      || (selection.excludedQueries?.length ?? 0) > 0;

    if (selection.all && !hasExclusions) {
      delete nextFilters[category];
      return nextFilters;
    }

    if (selection.all) {
      const optionNames = getCategoryOptionNames(category);
      const included = [
        ...new Set([
          ...selection.selected.filter((name) => isSubFilterOptionSelected(name, selection)),
          ...optionNames.filter((name) => isSubFilterOptionSelected(name, selection)),
        ]),
      ];
      if (!included.length) {
        delete nextFilters[category];
        return nextFilters;
      }
      nextFilters[category] = included;
      return nextFilters;
    }

    nextFilters[category] = selection.selected;
    return nextFilters;
  };

  const isCategoryActive = (category: keyof PeopleFilterSelections) => {
    const appliedSelection = getAppliedSelection(category);

    if (appliedSelection.all) {
      return appliedSelection.excluded.length > 0
        || (appliedSelection.excludedQueries?.length ?? 0) > 0;
    }

    return appliedSelection.selected.length > 0;
  };

  const hasActiveFilters = isCategoryActive('jobTitle')
    || isCategoryActive('jobLevel')
    || isCategoryActive('personality')
    || isCategoryActive('company')
    || isCategoryActive('region');

  const getMenuItemExtra = (
    category: keyof PeopleFilterSelections,
  ) => ({
    ...subMenuExtra,
    className: classNames({
      'active-filter-item': isCategoryActive(category),
    }),
  });

  const handleSubFilterChange = (
    category: keyof PeopleFilterSelections,
    selection: SubFilterSelection,
  ) => {
    setSelectedFilters((currentFilters) => ({
      ...currentFilters,
      [category]: selection,
    }));
  };

  const handleSubFilterApply = (category: string, selection: SubFilterSelection) => {
    const filterCategory = category as keyof PeopleFilterSelections;
    const normalized = normalizeSelection(selection);
    const nextFilters = toParentFilters(filters, filterCategory, normalized);

    const nextDraft = {
      ...appliedSelections,
      [filterCategory]: normalized,
    };

    setOpenKeys([]);
    setOpen(false);

    setFilters(nextFilters);
    setSelectedFilters(nextDraft);
    setAppliedSelections(nextDraft);

    requestAnimationFrame(() => {
      onApply?.(nextFilters);
    });
  };

  const items: MenuItem[] = [
    getItem('Job title',
      'jobTitle',
      <JobTitleIcon />,
      [getSubFilterChild('jobTitle',
        'Job title',
        designationData,
        hasMoreDesignations,
        onFetchMoreDesignations,
        designationsLoading,
        onDesignationSearch,
        getSelection('jobTitle'),
        isApplyDisabled('jobTitle'),
        (selected) => handleSubFilterChange('jobTitle', selected),
        handleSubFilterApply)],
      subMenuExtra
    ),
    getItem('Job level',
      'jobLevel',
      <JobLevelIcon />,
      [getSubFilterChild('jobLevel',
        'Job level',
        jobLevelData,
        undefined, undefined, undefined, undefined,
        getSelection('jobLevel'),
        isApplyDisabled('jobLevel'),
        (selected) => handleSubFilterChange('jobLevel', selected),
        handleSubFilterApply)],
      subMenuExtra
    ),
    getItem('Personality',
      'personality',
      <SinglePersonIcon />,
      [getSubFilterChild('personality',
        'Personality',
        personalityData,
        undefined, undefined, undefined, undefined,
        getSelection('personality'),
        isApplyDisabled('personality'),
        (selected) => handleSubFilterChange('personality', selected),
        handleSubFilterApply)],
      subMenuExtra
    ),
    getItem('Company',
      'company',
      <CompaniesSvg color="#7E7E7E" />,
      [getSubFilterChild('company',
        'Company',
        companyData,
        hasMoreCompanies,
        onFetchMoreCompanies,
        companiesLoading,
        onCompanySearch,
        getSelection('company'),
        isApplyDisabled('company'), (selected) =>
        handleSubFilterChange('company', selected),
        handleSubFilterApply)],
      subMenuExtra
    ),
    ...((!isSimilarPeople && !isFollowPeople) ? [
      getItem('Region',
        'region',
        <WorldIcon color="#7E7E7E" />,
        [getSubFilterChild('region',
          'Region',
          regionData,
          undefined, undefined, undefined, undefined,
          getSelection('region'),
          isApplyDisabled('region'),
          (selected) => handleSubFilterChange('region', selected),
          handleSubFilterApply)],
        subMenuExtra
      ),
    ] : []),
  ];

  const onOpenChange = (keys: string[]) => {
    const latestKey = keys.find((key) => !openKeys.includes(key));
    setOpenKeys(latestKey ? [latestKey] : keys);
  };

  const resetFilters = () => {
    setSelectedFilters({});
    setAppliedSelections({});
    setFilters({});
    setOpenKeys([]);
    setOpen(false);
    onApply?.({});

  };

  const content = (
    <ContentWrapper>
      <Menu
        style={{ width: isMob ? 230 : 274, borderRadius: 8 }}
        mode={'vertical'}
        items={items}
        expandIcon={<DownAngleIcon color="rgba(126, 126, 126, 1)" />}
        className="menu-for-people-filters"
        triggerSubMenuAction="click"
        subMenuCloseDelay={0}
        motion={{
          motionName: '',
          motionAppear: false,
          motionEnter: false,
          motionLeave: false,
        }}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        getPopupContainer={(node) => (
          isMob
            ? (node.closest('.people-filters-popup') as HTMLElement) || document.body
            : document.body
        )}
      />
      <span
        className={classNames("reset-button", { disabled: isResetDisabled })}
        role="button"
        tabIndex={0}
        onClick={resetFilters}
      >
        Reset
      </span>
    </ContentWrapper>
  );

  return (
    <ConfigProvider theme={{ token: { motion: false } }}>
      <StyleWrapper>
        <FiltersPopupStyle />
        <SubMenuPopupStyle />
        <Popover
          placement="bottomRight"
          content={content}
          trigger="click"
          open={open}
          destroyOnHidden
          transitionName=""
          onOpenChange={(newOpen) => {
            setOpen(newOpen);
            if (!newOpen) {
              setOpenKeys([]);
            }
          }}
          getPopupContainer={() => document.body}
          className="people-filters-popover"
          rootClassName="people-filters-popup"
          arrow={false}
          zIndex={1}
          autoAdjustOverflow={false}
        >
          <div
            aria-hidden="true"
            onClick={(e) => { e.stopPropagation(); }}
          >
            <GlobalButton
              title={isTab ? '' : 'Filter'}
              outlineColor={open || hasActiveFilters ? primaryColor : '#DADADA'}
              textColor={open || hasActiveFilters ? primaryColor : '#7E7E7E;'}
              bgColor={open || hasActiveFilters ? '#E8F8EC;' : '#fff'}
              innerSpace="9px 12px"
              onButtonClick={() => { }}
              RightSeparator={isTab ? false : true}
              height="38px"
              IconRight={isTab ? <FilterNewIcon /> : <DownAngleIcon color={open || hasActiveFilters ? primaryColor : 'rgba(126, 126, 126, 1)'} />}
              buttonClassName={classNames({ activeBtnState: open })}
              disabled={disabled}
            />
          </div>
        </Popover>
      </StyleWrapper>
    </ConfigProvider>
  );
};

PeopleFilters.defaultProps = defaultProps;
export default PeopleFilters;
